import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import type { AreaContentDraft } from "@/lib/areas";
import ThingsToDoEditor from "@/components/admin/ThingsToDoEditor";

const AreaContentFields = ({ value, onChange }: { value: AreaContentDraft; onChange: (next: AreaContentDraft) => void }) => {
  const set = (patch: Partial<AreaContentDraft>) => onChange({ ...value, ...patch });
  return (
    <div className="grid sm:grid-cols-2 gap-4">
      <div>
        <label className="text-sm font-medium mb-1 block">Short description</label>
        <Textarea value={value.shortDescription} onChange={(e) => set({ shortDescription: e.target.value })} rows={3} className="rounded-xl resize-none" />
      </div>
      <div>
        <label className="text-sm font-medium mb-1 block">Tags (comma separated)</label>
        <Input value={value.tags} onChange={(e) => set({ tags: e.target.value })} className="rounded-xl" placeholder="Surf, Social, Walkable" />
      </div>
      <div>
        <label className="text-sm font-medium mb-1 block">Best for</label>
        <Input value={value.bestFor} onChange={(e) => set({ bestFor: e.target.value })} className="rounded-xl" />
      </div>
      <div>
        <label className="text-sm font-medium mb-1 block">Vibe</label>
        <Input value={value.vibe} onChange={(e) => set({ vibe: e.target.value })} className="rounded-xl" />
      </div>
      <div className="sm:col-span-2">
        <label className="text-sm font-medium mb-1 block">Access</label>
        <Input value={value.access} onChange={(e) => set({ access: e.target.value })} className="rounded-xl" />
      </div>
      <div>
        <label className="text-sm font-medium mb-1 block">Location bullets (one per line)</label>
        <Textarea value={value.locationBullets} onChange={(e) => set({ locationBullets: e.target.value })} rows={4} className="rounded-xl resize-none" />
      </div>
      <div>
        <label className="text-sm font-medium mb-1 block">Known for (one per line)</label>
        <Textarea value={value.knownFor} onChange={(e) => set({ knownFor: e.target.value })} rows={4} className="rounded-xl resize-none" />
      </div>
      <div className="sm:col-span-2">
        <label className="text-sm font-medium mb-1 block">SEO title</label>
        <Input value={value.seoTitle} onChange={(e) => set({ seoTitle: e.target.value })} className="rounded-xl" />
      </div>
      <div className="sm:col-span-2">
        <label className="text-sm font-medium mb-1 block">SEO description</label>
        <Textarea value={value.seoDescription} onChange={(e) => set({ seoDescription: e.target.value })} rows={2} className="rounded-xl resize-none" />
      </div>
      <div className="sm:col-span-2">
        <label className="text-sm font-medium mb-1 block">About body (use blank lines to separate paragraphs)</label>
        <Textarea value={value.seoText} onChange={(e) => set({ seoText: e.target.value })} rows={8} className="rounded-xl resize-none" />
      </div>
      <div className="sm:col-span-2">
        <label className="text-sm font-medium mb-1 block">Things to do nearby</label>
        <p className="text-[12px] text-muted-foreground mb-2">Surf breaks, restaurants, yoga, waterfalls, supermarkets, shown on the area page and on collection pages for this area.</p>
        <ThingsToDoEditor value={value.thingsToDo} onChange={(thingsToDo) => set({ thingsToDo })} />
      </div>
    </div>
  );
};

export default AreaContentFields;
